export default "__VITE_ASSET__CKabNFsP__"